import { MessageHistory } from '@tmx/data-access';

export class HistoricalNotification {
  externalId: string;
  message: string;
  sentTimestamp: Date | null;
  receivedTimestamp: Date | null;

  constructor(messageHistory: MessageHistory) {
    this.externalId = messageHistory.userId;
    this.message = messageHistory.messageBody?.keytest1 ?? '';
    this.sentTimestamp = messageHistory.sentTimestamp;
    this.receivedTimestamp = messageHistory.acknowledgedTimestamp;
  }
}
